<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("cinemasettings") }}
      </div>
      <router-link class="btn-blue" to="cinema-settings"
        >{{ $t("cinemasettings") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="edit-movie-container">
      <form class="" v-on:submit.prevent.self="onFinalSubmit(true)">
        <div class="row new-border rounded-10 back m-0 pt-4">
          <!-- CINEMAS SELECTION -->
          <div class="col-md-3 mb-1">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="selectedCinema"
                name="selectcinema"
                id="selectcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p
              v-if="submitted && selectedCinema.length == 0"
              class="error_message"
              style="margin-top:2px"
            >
              Please Select Cinema.
            </p>
          </div>

          <div class="col-md-3 mb-1">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selected_day ? 'shift-up' : ''">{{
                  $t("start_day")
                }}</label>
                <multiselect
                  v-model="selected_day"
                  :options="Days"
                  track-by="id"
                  label="day"
                  :multiple="false"
                  @select="onSelectDay($event)"
                  v-b-tooltip.hover
                  :title="$t('start_day')"
                ></multiselect>
              </div>
              <!--Tooltip :title="$t('start_day')" /-->
            </div>
            <p class="error_message">
              <span v-if="submitted && !cinema_config.start_day"
                >Please Select Day.</span
              >
            </p>
          </div>

          <div class="col-md-2 mb-1">
            <div class="dropdown-curve-container">
              <label :class="cinema_config.start_time ? 'shift-up' : ''">{{
                $t("businessStartTime")
              }}</label>
              <vue-timepicker
                manual-input
                v-model="cinema_config.start_time"
                name="operationstime"
                id="operationstime"
                format="HH:mm"
                :placeholder="$t('businessStartTime')"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                @change="onChangeTime($event, 'start')"
                v-validate="'required'"
              ></vue-timepicker>
            </div>
            <!-- <date-picker
                v-model="cinema_config.cine_operation_start_time"
                lang="en"
                type="time"
                format="hh:mm a"
                :minute-step="1"
                class="time_picker"
                placeholder="Operation Start Time"
                name="operationstime"
                id="operationstime"
                v-validate="'required'"
              ></date-picker> -->

            <p
              v-if="submitted && errors.has('operationstime')"
              class="error_msg"
            >
              {{ errors.first("operationstime") }}
            </p>
          </div>
          <div class="col-md-2 mb-1">
            <div class="dropdown-curve-container">
              <label :class="cinema_config.end_time ? 'shift-up' : ''">{{
                $t("businessEndTime")
              }}</label>
              <vue-timepicker
                manual-input
                v-model="cinema_config.end_time"
                name="operationetime"
                id="operationetime"
                format="HH:mm"
                :placeholder="$t('businessEndTime')"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                @change="onChangeTime($event, 'end')"
                v-validate="'required'"
              ></vue-timepicker>
            </div>

            <!-- <date-picker
                v-model="cinema_config.cine_operation_end_time"
                lang="en"
                type="time"
                format="hh:mm a"
                :minute-step="1"
                class="time_picker"
                placeholder="Operation End Time"
                name="operationetime"
                id="operationetime"
                v-validate="'required'"
              ></date-picker> -->
            <p
              v-if="submitted && errors.has('operationetime')"
              class="error_msg"
            >
              {{ errors.first("operationetime") }}
            </p>
          </div>

          <!---Active btn--->
          <div
            class="col-md-2 d-flex align-self-center mb-4 justify-content-end"
          >
            <label>{{ $t("active") }}</label>
            <div class="ml-3">
              <b-form-checkbox
                v-model="cinema_config.cine_setting_is_active"
                value="Y"
                unchecked-value="N"
                name="check-button"
                class="j-checkbox"
              ></b-form-checkbox>
            </div>
          </div>

          <!--Cutoff Row--->
          <div class="mx-3 back-white w-100 mb-4">
            <div class="col-md-12 mb-3  pt-2">
              <h5 class="heading">Cutoff Time (in mins)</h5>
            </div>

            <div class="col-12">
              <div class="row ">
                <div class="col-md-4 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        style="text-align:right"
                        placeholder="."
                        v-model="cinema_config.cine_cutoff_time_in_mins"
                        type="text"
                        name="cutofftime"
                        id="cutofftime"
                        v-validate="{ required: 'required', regex: /-?\d+/ }"
                        v-b-tooltip.hover
                        :title="$t('cinemaSettingsCutofTime_tooltip')"
                      />
                      <label>{{ $t("Pos_new") }}</label>
                    </div>
                    <!---Tooltip :title="$t('cinemaSettingsCutofTime_tooltip')" /--->
                  </div>
                  <p
                    v-if="submitted && errors.has('cutofftime')"
                    class="error_message"
                  >
                    <!-- {{ item.fieldname }} -->
                    {{ errors.first("cutofftime") }}
                  </p>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        style="text-align:right"
                        placeholder="."
                        v-model="cinema_config.kiosk_cutoff_time_in_mins"
                        type="text"
                        name="kioskcutofftime"
                        id="kioskcutofftime"
                        v-validate="{ required: 'required', regex: /-?\d+/ }"
                        v-b-tooltip.hover
                        :title="$t('cinemaSettingsCutofTime_tooltip')"
                      />
                      <label>{{ $t("Kiosk_new") }}</label>
                    </div>
                    <!--Tooltip :title="$t('cinemaSettingsCutofTime_tooltip')" /-->
                  </div>
                  <p
                    v-if="submitted && errors.has('kioskcutofftime')"
                    class="error_message"
                  >
                    <!-- {{ item.fieldname }} -->
                    {{ errors.first("kioskcutofftime") }}
                  </p>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        style="text-align:right"
                        placeholder="."
                        v-model="cinema_config.website_cutoff_time_in_mins"
                        type="text"
                        name="websitecutofftime"
                        id="websitecutofftime"
                        v-validate="{ required: 'required', regex: /-?\d+/ }"
                        v-b-tooltip.hover
                        :title="$t('cinemaSettingsCutofTime_tooltip')"
                      />
                      <label>{{ $t("website_new") }}</label>
                    </div>
                    <!--Tooltip :title="$t('cinemaSettingsCutofTime_tooltip')" /--->
                  </div>
                  <p
                    v-if="submitted && errors.has('websitecutofftime')"
                    class="error_message"
                  >
                    <!-- {{ item.fieldname }} -->
                    {{ errors.first("websitecutofftime") }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!---Entry Row--->
          <div class="mx-3 back-white w-100 mb-4">
            <div class="col-12">
              <div class="row pt-2">
                <h5 class="heading col-4 align-self-center mb-2">
                  Entry Allowed(in mins)
                </h5>
                <div class="col-md-4 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        style="text-align:right"
                        placeholder="."
                        v-model="cinema_config.entry_before_show_start"
                        type="number"
                        name="entry_before_show_start"
                        id="entry_before_show_start"
                        v-validate="'required|numeric'"
                        v-b-tooltip.hover
                        :title="$t('entry_before_show_start_tooltip')"
                      />
                      <label>{{ $t("before_show_start") }} </label>
                    </div>
                    <!--Tooltip :title="$t('entry_before_show_start_tooltip')" /-->
                  </div>
                  <p
                    v-if="submitted && errors.has('entry_before_show_start')"
                    class="error_message"
                  >
                    <!-- {{ item.fieldname }} -->
                    {{ $t("before_show_start_required") }}
                  </p>
                </div>

                <div class="col-md-4 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        style="text-align:right"
                        placeholder="."
                        v-model="cinema_config.entry_after_show_start"
                        type="number"
                        name="entry_after_show_start"
                        id="entry_after_show_start"
                        v-validate="'required|numeric'"
                        v-b-tooltip.hover
                        :title="$t('entry_after_show_start_tooltip')"
                      />
                      <label>{{ $t("after_show_start") }} </label>
                    </div>
                    <!--Tooltip :title="$t('entry_after_show_start_tooltip')" /-->
                  </div>
                  <p
                    v-if="submitted && errors.has('entry_after_show_start')"
                    class="error_message"
                  >
                    <!-- {{ item.fieldname }} -->
                    {{ $t("entry_after_show_start_required") }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  style="text-align:right"
                  placeholder="."
                  v-model="cinema_config.cine_cleaning_time_in_mins"
                  type="text"
                  name="cleaningtime"
                  id="cleaningtime"
                  v-validate="'required|numeric'"
                  v-b-tooltip.hover
                  :title="$t('cinemaSettingsCleaningTime_tooltip')"
                />
                <label>{{ $t("cleaningtime") }} ( {{ $t("inmins") }} )</label>
              </div>
              <!---Tooltip :title="$t('cinemaSettingsCleaningTime_tooltip')" /--->
            </div>
            <p
              v-if="submitted && errors.has('cleaningtime')"
              class="error_message"
            >
              {{ errors.first("cleaningtime") }}
            </p>
          </div>

          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  style="text-align:right"
                  placeholder="."
                  v-model="cinema_config.cine_setting_ads_time_in_mins"
                  type="text"
                  name="settingadstime"
                  id="settingadstime"
                  v-validate="'required|numeric'"
                  v-b-tooltip.hover
                  :title="$t('cinemaSettingsAdvertisementTime_tooltip')"
                />
                <label>{{ $t("advertisementtime") }}</label>
              </div>
              <!--Tooltip :title="$t('cinemaSettingsAdvertisementTime_tooltip')" /-->
            </div>
            <p
              v-if="submitted && errors.has('settingadstime')"
              class="error_message"
            >
              {{ errors.first("settingadstime") }}
            </p>
          </div>

          <!-- intervaltime -->
          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  style="text-align:right"
                  placeholder="."
                  v-model="cinema_config.cine_interval_time_in_mins"
                  type="text"
                  name="intervaltime"
                  id="intervaltime"
                  v-validate="'required|numeric'"
                  v-b-tooltip.hover
                  :title="$t('cinemaSettingsAdvertisementTime_tooltip')"
                />
                <label>{{ $t("intervaltime") }}</label>
              </div>
              <!--Tooltip :title="$t('cinemaSettingsAdvertisementTime_tooltip')" /--->
            </div>
            <p
              v-if="submitted && errors.has('intervaltime')"
              class="error_message"
            >
              <!-- {{ item.fieldname }} -->
              {{ errors.first("intervaltime") }}
            </p>
          </div>

          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  style="text-align:right"
                  placeholder="."
                  v-model="cinema_config.cine_seat_release_time_in_mins"
                  type="text"
                  name="releasetime"
                  id="releasetime"
                  v-validate="'required|numeric'"
                  v-b-tooltip.hover
                  :title="$t('cinemaSettingsSeatReleaseTime_tooltip')"
                />
                <label>{{ $t("seatreleasetime") }}</label>
              </div>
              <!--Tooltip :title="$t('cinemaSettingsSeatReleaseTime_tooltip')" /-->
            </div>
            <p
              v-if="submitted && errors.has('releasetime')"
              class="error_message"
            >
              <!-- {{ item.fieldname }} -->
              {{ errors.first("releasetime") }}
            </p>
          </div>

          <div
            class="col-md-4 mb-4"
            v-if="screens.length > 0 && getMyCinemaStatusNew() == 'Y'"
          >
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  style="text-align:right"
                  placeholder="."
                  v-model="cinema_config.mycinema_creation_interval"
                  type="text"
                  name="mycinema_creation_interval_time"
                  id="mycinema_creation_interval_time"
                  v-validate="'numeric'"
                  v-b-tooltip.hover
                  :title="
                    $store.getters.isGogoCinema == 'Y'
                      ? $t('cinemaSettings_ondemand_creation_interval_tooltip')
                      : $t('cinemaSettings_mycinema_creation_interval_tooltip')
                  "
                />
                <label
                  >{{
                    $store.getters.isGogoCinema == "Y"
                      ? $t("ondemand_creation_interval_time")
                      : $t("mycinema_creation_interval_time")
                  }}
                </label>
              </div>
              <!--Tooltip
              :title="
                $store.getters.isGogoCinema == 'Y'
                  ? $t('cinemaSettings_ondemand_creation_interval_tooltip')
                  : $t('cinemaSettings_mycinema_creation_interval_tooltip')
              "
            /-->
            </div>
            <p
              v-if="submitted && errors.has('mycinema_creation_interval_time')"
              class="error_message"
            >
              <!-- {{ item.fieldname }} -->
              {{ errors.first("mycinema_creation_interval_time") }}
            </p>
          </div>

          <!-- LEAD TIME HH-->
          <div class="col-md-4 mb-4" v-if="getMyCinemaStatusNew() == 'Y'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  style="text-align:right"
                  placeholder="."
                  v-model="leadTimeHH"
                  type="text"
                  name="leadTimeHH"
                  id="leadTimeHH"
                  v-validate="'numeric'"
                  @input="onChangeLeadTime($event, 'HH')"
                  v-b-tooltip.hover
                  :title="'Time before cinema starts'"
                />
                <label>Lead Time (HH)</label>
              </div>
              <!--Tooltip :title="'Time before cinema starts'" /-->
            </div>
            <p
              v-if="submitted && errors.has('leadTimeHH')"
              class="error_message"
            >
              {{ errors.first("leadTimeHH") }}
            </p>
          </div>
          <!-- LEAD TIME MM-->
          <div class="col-md-4 mb-4" v-if="getMyCinemaStatusNew() == 'Y'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  style="text-align:right"
                  placeholder="."
                  v-model="leadTimeMM"
                  type="text"
                  name="leadTimeMM"
                  id="leadTimeMM"
                  maxlength="2"
                  v-validate="'numeric'"
                  @input="onChangeLeadTime($event, 'MM')"
                  v-b-tooltip.hover
                  :title="'Time before cinema starts'"
                />
                <label>Lead Time (MM)</label>
              </div>
              <!--Tooltip :title="'Time before cinema starts'" /--->
            </div>
            <p
              v-if="submitted && errors.has('leadTimeMM')"
              class="error_message"
            >
              {{ errors.first("leadTimeMM") }}
            </p>
          </div>

          <!-- PO USER MULTISELECT -->
          <div class="col-md-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedApprovalUsers ? 'shift-up' : ''">
                  {{ $tc("PO User", 1) }}
                </label>
                <multiselect
                  v-model="selectedApprovalUsers"
                  :options="ApprovalUsers"
                  track-by="user_id"
                  label="username"
                  :multiple="true"
                  @select="selectPoUser($event)"
                  name="selectPOuser"
                  id="selectPOuser"
                  select-label="Select"
                  deselect-label="Remove"
                  placeholder="Users"
                  v-b-tooltip.hover
                  :title="'Users with permissions to approve Purchase orders'"
                ></multiselect>
              </div>
              <!--Tooltip
              :title="'Users with permissions to approve Purchase orders'"
            /-->
            </div>
          </div>
          <!--Ip address-->
          <div class="col-md-3 mb-2">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  v-model="cinema_config.cine_ipaddress_range"
                  type="text"
                  name="ipaddress"
                  id="ipaddress"
                  v-validate="{
                    required: 'required',
                    regex: /[\d*]+\.[\d*]+\.[\d*]+\.[\d*]+/,
                  }"
                  v-b-tooltip.hover
                  :title="$t('IpAddressRange_tooltip')"
                />
                <!-- /^[0-9]{1,3}([.][0-9]{1,3})([.][0-9]{1,3})([.][0-9]{1,3})?$/ -->
                <label>{{ $t("ipaddressrange") }}</label>
              </div>
              <!--Tooltip :title="$t('IpAddressRange_tooltip')" /--->
            </div>
            <p
              v-if="submitted && errors.has('ipaddress')"
              class="error_message"
            >
              {{ errors.first("ipaddress") }}
            </p>
          </div>

          <div class="col-md-3 mb-4">
            <div class="row">
              <div class="col-10">
                <div class="d-flex align-items-center">
                  <label
                    class="material-file-upload"
                    @click.prevent.stop="setModalData()"
                    v-b-tooltip.hover
                    :title="
                      `Temporary Movie Artwork Image - ${set_width} X ${set_height}`
                    "
                  >
                    <div
                      class="label"
                      v-bind:class="{
                        'shift-up': cinema_config.temp_artwork_image_path,
                      }"
                    >
                      {{ "Temporary Artwork" }}
                    </div>
                    <!---{{ "- " + set_width + " X " + set_height }}--->
                    <div class="uploaded-file-name">
                      <div class="text-truncate pt-2">
                        {{ cinema_config.temp_artwork_image_path }}
                      </div>
                    </div>
                  </label>
                  <!--Tooltip
                  :title="
                    `Temporary Movie Artwork Image - ${set_width} X ${set_height}`
                  "
                /-->
                </div>
              </div>
              <div class="col-2 align-self-center pl-3">
                <img
                  width="40"
                  height="40"
                  class="rounded c-pointer img-preview"
                  @click="openImageModal()"
                  :src="_GetImagePath(cinema_config.temp_artwork_image_path)"
                  v-if="cinema_config.temp_artwork_image_path"
                />
                <img
                  v-else
                  width="35"
                  height="35"
                  class="rounded"
                  alt="Empty Image"
                  src="@/assets/img/icons/empty-image.svg"
                />
              </div>
            </div>
          </div>

          <div class="col-md-3 mb-2">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="cinema_config.cine_time_zone ? 'shift-up' : ''"
                  >{{ $t("timeZoneTitle") }}</label
                >
                <multiselect
                  v-model="cinema_config.cine_time_zone"
                  :options="timeZones"
                  track-by="tz_id"
                  label="tz_name"
                  :multiple="false"
                  v-b-tooltip.hover
                  :title="$t('timezone')"
                ></multiselect>
              </div>
              <!--Tooltip :title="$t('timezone')" /-->
            </div>
            <p class="error_message">
              <span v-if="submitted && cinema_config.cine_time_zone.length == 0"
                >Please Select Time Zone.</span
              >
            </p>
          </div>

          <div class="col-md-2 mb-2" v-if="isEmpireClient">
            <div class="dropdown-curve-container">
              <label :class="cinema_config.fnb_start_time ? 'shift-up' : ''">{{
                $t("FnbStartTime")
              }}</label>
              <vue-timepicker
                manual-input
                v-model="cinema_config.fnb_start_time"
                name="FnbStartTime"
                id="FnbStartTime"
                format="HH:mm"
                :placeholder="''"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                @change="onChangeFnbTime($event, 'start')"
              ></vue-timepicker>
            </div>
          </div>
          <div class="col-md-2 mb-2" v-if="isEmpireClient">
            <div class="dropdown-curve-container">
              <label :class="cinema_config.fnb_end_time ? 'shift-up' : ''">{{
                $t("FnbEndTime")
              }}</label>
              <vue-timepicker
                manual-input
                v-model="cinema_config.fnb_end_time"
                name="FnbEndTime"
                id="FnbEndTime"
                format="HH:mm"
                :placeholder="''"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                @change="onChangeFnbTime($event, 'end')"
              ></vue-timepicker>
            </div>
          </div>
        </div>

        <div
          v-if="getMyCinemaStatusNew() == 'Y'"
          class="col-12 row new-border rounded-10 back mx-0 mt-3 mb-0 pt-2"
        >
          <div class="mr-3">
            <label style="font-weight:bold;"> Show Type: </label>
          </div>
          <div
            class="mr-2 mb-2 ml-1 d-flex justify-content-start align-items-center px-0"
            v-for="(item, index_s) in ShowTypeArray"
            :key="index_s + item.screening_name"
          >
            <input
              type="checkbox"
              class="ios-checkbox"
              v-model="item.status"
              style="height: 15px; width: 15px; margin-right: 5px"
            />
            <span class="switch-slider"> {{ item.screening_name }}</span>
          </div>
        </div>

        <div
          class="align-items-center row new-border rounded-10 back mx-0 mt-3 mb-0 pt-2"
          v-if="getMyCinemaStatusNew() == 'Y' && screens.length > 0"
        >
          <div
            class="col-12 d-flex ml-0 pl-2 align-items-center"
            v-if="screens.length > 0"
          >
            <p class="mb-2" style="font-weight:bold;">
              {{
                $store.getters.isGogoCinema == "Y"
                  ? $t("select_ondemand_screens")
                  : $t("select_mycinema_screens")
              }}
            </p>

            <div class="ml-2" v-if="screens.length > 0">
              <b-button
                v-for="(screen, screenIndex) in screens"
                :key="screenIndex"
                :class="
                  `mx-1 cursor-pointer custom-button mb-2 custom-button-no-hover`
                "
                @click="onClickScreen($event, screen, screenIndex)"
                :variant="
                  selectedScreens.findIndex(
                    (x) => x.screen_id == screen.screen_id
                  ) !== -1
                    ? 'primary'
                    : 'outline-primary'
                "
                >{{ screen.screen_name }}</b-button
              >
            </div>
          </div>
        </div>

        <!-- REDEEMABLE ON NET-VALUE / GROSS AMOUNT  -->
        <div
          class="col-md-12  align-items-center new-border rounded-10 back mx-0 mt-3 mb-0 py-2"
          v-if="false"
        >
          <div class="d-flex align-items-center">
            <span style="font-weight:bold">Discount is available on :</span>
            <b-form-radio
              value="NetAmount"
              class="j-radio ml-2"
              v-model="cinema_config.discount_is_available_on"
            >
              <div>
                <span>Net Amount</span>
              </div>
            </b-form-radio>

            <b-form-radio
              value="GrossAmount"
              class="j-radio ml-2"
              v-model="cinema_config.discount_is_available_on"
            >
              <div>
                <span>Gross Amount</span>
              </div>
            </b-form-radio>
          </div>
        </div>

        <div
          class="row align-items-center new-border rounded-10 back mx-0 mt-3 mb-0 py-2"
        >
          <div class="d-flex align-items-center col-12 mb-2">
            <span style="font-weight:bold">Discount is available on :</span>
            <b-form-radio
              value="NetAmount"
              class="j-radio ml-2"
              v-model="cinema_config.discount_is_available_on"
            >
              <div>
                <span>Net Amount</span>
              </div>
            </b-form-radio>

            <b-form-radio
              value="GrossAmount"
              class="j-radio ml-2"
              v-model="cinema_config.discount_is_available_on"
            >
              <div>
                <span>Gross Amount</span>
              </div>
            </b-form-radio>
          </div>

          <div class="col-md-4 col-xl-3 d-flex">
            <b-form-checkbox
              v-model="cinema_config.cine_online_visibility"
              value="Y"
              unchecked-value="N"
              name="check-button"
              class="j-checkbox mr-2"
            ></b-form-checkbox>
            <label>{{ $t("onlinevisibility") }}</label>
          </div>

          <div class="col-md-4 col-xl-3 d-flex">
            <b-form-checkbox
              v-model="cinema_config.cine_sell_fnb_in_boxoffice"
              value="Y"
              unchecked-value="N"
              name="check-button"
              class="j-checkbox mr-2"
            ></b-form-checkbox>

            <label>{{ $t("sellinboxoffice") }}</label>
          </div>

          <div class="col-md-4 col-xl-3 d-flex">
            <b-form-checkbox
              v-model="cinema_config.cine_include_float_amount"
              value="Y"
              unchecked-value="N"
              name="check-button"
              class="j-checkbox mr-2"
            ></b-form-checkbox>

            <label>{{ $t("include") }} {{ $t("floatAmount") }}</label>
          </div>

          <div class="col-md-4 col-xl-3 d-flex">
            <b-form-checkbox
              v-model="cinema_config.cine_include_shift_close"
              value="Y"
              unchecked-value="N"
              name="check-button"
              class="j-checkbox mr-2"
            ></b-form-checkbox>

            <label>{{ $t("include") }} {{ $t("shiftclose") }}</label>
          </div>

          <div class="col-md-4 col-xl-3 d-flex">
            <b-form-checkbox
              v-model="cinema_config.cine_display_24hr_time"
              value="Y"
              unchecked-value="N"
              name="check-button"
              class="j-checkbox mr-2"
            ></b-form-checkbox>

            <label>{{ $t("24") }}{{ $t("hr_display_time") }}</label>
          </div>

          <div class="col-md-4 col-xl-3 d-flex">
            <b-form-checkbox
              v-model="cinema_config.cine_direct_sale"
              value="Y"
              unchecked-value="N"
              name="check-button"
              class="j-checkbox mr-2"
            ></b-form-checkbox>

            <label>{{ $t("directsale") }}</label>
          </div>

          <div class="col-md-4 col-xl-3 d-flex">
            <b-form-checkbox
              v-model="cinema_config.cine_sell_fnb_online"
              value="Y"
              unchecked-value="N"
              name="check-button"
              class="j-checkbox mr-2"
            ></b-form-checkbox>

            <label>{{ $t("sellinonline") }}</label>
          </div>

          <div class="col-md-4 col-xl-3 d-flex" v-if="isEmpireClient">
            <b-form-checkbox
              v-model="cinema_config.optional_ticket_print"
              value="N"
              unchecked-value="Y"
              name="check-button"
              switch
              class="j-checkbox mr-2"
            ></b-form-checkbox>
            <label>{{ $t("DirectPrintOff") }}</label>
          </div>
        </div>

        <div class="col-md-6 mb-4" v-if="false">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("onlinevisibility") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <b-form-checkbox
                v-model="cinema_config.cine_online_visibility"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-4" v-if="false">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("sellinboxoffice") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <b-form-checkbox
                v-model="cinema_config.cine_sell_fnb_in_boxoffice"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-4" v-if="false">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("include") }} {{ $t("floatAmount") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <b-form-checkbox
                v-model="cinema_config.cine_include_float_amount"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-4" v-if="false">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("include") }} {{ $t("shiftclose") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <b-form-checkbox
                v-model="cinema_config.cine_include_shift_close"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-4" v-if="false">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("24") }}{{ $t("hr_display_time") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <b-form-checkbox
                v-model="cinema_config.cine_display_24hr_time"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-4" v-if="false">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("directsale") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div>
                <b-form-checkbox
                  v-model="cinema_config.cine_direct_sale"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-4" v-if="false">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("sellinonline") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <b-form-checkbox
                v-model="cinema_config.cine_sell_fnb_online"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="row"></div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="row"></div>
        </div>

        <section class="mb-5 w-100  cms-section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-collapse-box"
            v-b-toggle.cmsBlock
          >
            <span> {{ $t("CMS") }} </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="cmsBlock"
            class="mt-2"
            v-model="sectionCollapse.cmsBlock"
          >
            <div class="bn-tabs-nav">
              <button
                v-for="(content, contentIndex) in CMS"
                :key="contentIndex"
                :class="[
                  'btn-tab-title ',
                  { active: contentIndex == activeClass },
                ]"
                @click.prevent.stop="onChangeTabHandler($event, contentIndex)"
              >
                <strong>
                  <span :class="notempty[contentIndex] ? '' : 'text-danger'">{{
                    content.langauge
                  }}</span>
                </strong>
              </button>
            </div>
            <div class="bn-tabs-content">
              <div v-for="(content, contentIndex) in CMS" :key="contentIndex">
                <div v-if="contentIndex === activeClass">
                  <div class="row mx-0 rounded mb-2">
                    <div class="col-12 px-0">
                      <div class="row">
                        <div class="col-lg-4 col-xl-4 mb-1">
                          <div
                            class="d-flex justify-content-between align-item-center"
                          >
                            <label
                              class="material-file-upload cms_header_image"
                              @click.prevent.stop="
                                setCMSImageData('CMS_header', contentIndex)
                              "
                            >
                              <div
                                class="label"
                                v-bind:class="{
                                  'shift-up': content.cmsHeader.image_url,
                                }"
                                v-b-tooltip.hover
                                :title="`cinema header Image`"
                              >
                                {{ "Cinema Header Image" }}
                              </div>
                              <div class="uploaded-file-name">
                                <div class="text-truncate pt-2">
                                  {{ content.cmsHeader.image_url }}
                                </div>
                              </div>
                            </label>

                            <!--Tooltip
                              class="mt-2"
                              :title="`cinema header Image`"
                            /-->
                            <img
                              width="40"
                              height="40"
                              class="rounded c-pointer ml-2"
                              @click="
                                openImageModal(
                                  'CMS_header',
                                  contentIndex,
                                  index
                                )
                              "
                              :src="_GetImagePath(content.cmsHeader.image_url)"
                              v-if="content.cmsHeader.image_url"
                            />
                            <img
                              v-else
                              width="35"
                              height="35"
                              class="rounded ml-2"
                              alt="Empty Image"
                              src="@/assets/img/icons/empty-image.svg"
                            />
                          </div>
                        </div>
                        <div class="col-lg-4 col-xl-4 mb-1">
                          <div class="d-flex align-items-center">
                            <div class="dropdown-curve-container">
                              <label
                                :class="
                                  content.cmsHeader &&
                                  content.cmsHeader.sound_formats &&
                                  content.cmsHeader.sound_formats.length > 0
                                    ? 'shift-up'
                                    : ''
                                "
                              >
                                Available {{ $tc("Sound", 1) }}
                                {{ $tc("Format", 1) }}
                              </label>
                              <multiselect
                                v-model="content.cmsHeader.sound_formats"
                                @remove="$forceUpdate()"
                                @select="$forceUpdate()"
                                :multiple="true"
                                :options="soundFormatList"
                                :searchable="true"
                                label="sound_format_name"
                                track-by="sound_format_id"
                                placeholder=""
                                select-label="Select"
                                deselect-label="Remove"
                                v-b-tooltip.hover
                                :title="$t('available_sound_formats')"
                              ></multiselect>
                            </div>
                            <!--Tooltip :title="$t('available_sound_formats')" /-->
                          </div>
                          <p class="error_message"></p>
                        </div>

                        <div class="col-md-4 mb-1">
                          <div class="row justify-content-center pt-2">
                            <div>
                              <b-form-checkbox
                                v-model="content.cmsHeader.show_cinema_address"
                                value="Y"
                                unchecked-value="N"
                                name="check-button"
                                class="j-checkbox ml-2"
                              ></b-form-checkbox>
                            </div>

                            <label class="mb-0">Show Cinema Address</label>
                          </div>
                        </div>

                        <div class="col-lg-12 col-xl-12 align-self-center mb-3">
                          <div class="d-flex align-items-center">
                            <div class="input-material-textarea">
                              <textarea
                                v-model="content.cmsHeader.description"
                                rows="4"
                                placeholder="."
                                name="description"
                                v-b-tooltip.hover
                                :title="$t('cms_desc')"
                              ></textarea>
                              <label>Cinema Sub-Header</label>
                            </div>
                            <!--Tooltip :title="$t('cms_desc')" /-->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="content.cmsData.length > 0" class="">
                    <div
                      class="row mx-0 mb-4 back new-border rounded-10 "
                      v-for="(item, index) in content.cmsData"
                      :key="index"
                    >
                      <div class="col-11">
                        <div class="col-12">
                          <div class="row py-4 ">
                            <div
                              class="col-lg-6 col-xl-6 align-self-center mb-3"
                            >
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <input
                                    placeholder="Title"
                                    type="text"
                                    name="title"
                                    v-model="item.title"
                                    @input="
                                      CheckEmptyContent(
                                        item,
                                        index,
                                        contentIndex
                                      )
                                    "
                                    v-b-tooltip.hover
                                    :title="$t('cms_title')"
                                  />
                                  <label>{{ $t("cms_title") }}</label>
                                </div>
                                <!--Tooltip :title="$t('cms_title')" /--->
                              </div>
                            </div>

                            <div class="col-lg-6 col-xl-6 mb-3">
                              <div
                                class="d-flex justify-content-between align-item-center"
                              >
                                <label
                                  class="material-file-upload"
                                  style="background-color:white;"
                                  @click.prevent.stop="
                                    setCMSImageData('CMS', contentIndex, index)
                                  "
                                  v-b-tooltip.hover
                                  :title="`CMS Image`"
                                >
                                  <div
                                    class="label"
                                    v-bind:class="{
                                      'shift-up': item.image_url,
                                    }"
                                  >
                                    {{ "CMS Image" }}
                                  </div>
                                  <div class="uploaded-file-name">
                                    <div
                                      class="text-truncate pt-2 image_url_text"
                                    >
                                      {{ item.image_url }}
                                    </div>
                                  </div>
                                </label>

                                <!--Tooltip class="mt-2" :title="`CMS Image`" /-->
                                <img
                                  width="40"
                                  height="40"
                                  class="rounded c-pointer ml-2"
                                  @click="
                                    openImageModal('CMS', contentIndex, index)
                                  "
                                  :src="_GetImagePath(item.image_url)"
                                  v-if="item.image_url"
                                />
                                <img
                                  v-else
                                  width="35"
                                  height="35"
                                  class="rounded ml-2"
                                  alt="Empty Image"
                                  src="@/assets/img/icons/empty-image.svg"
                                />
                              </div>
                            </div>

                            <div
                              class="col-lg-12 col-xl-12 align-self-center mb-3"
                            >
                              <div class="d-flex align-items-center">
                                <div class="input-material-textarea">
                                  <textarea
                                    v-model="item.description"
                                    rows="4"
                                    placeholder="."
                                    name="description"
                                    @input="
                                      CheckEmptyContent(
                                        item,
                                        index,
                                        contentIndex
                                      )
                                    "
                                    v-b-tooltip.hover
                                    :title="$t('cms_desc')"
                                  ></textarea>
                                  <label>{{ $t("cms_desc") }}</label>
                                </div>
                                <!--Tooltip :title="$t('cms_desc')" /-->
                              </div>
                            </div>
                            <div
                              class="col-lg-6 col-xl-6 align-self-center mb-0"
                            >
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <input
                                    placeholder="Description"
                                    type="text"
                                    name="desc"
                                    v-model="item.button_text"
                                    v-b-tooltip.hover
                                    :title="$t('cms_btn_tooltip')"
                                  />
                                  <label>{{ $t("cms_btn_text") }}</label>
                                </div>
                                <!--Tooltip :title="$t('cms_btn_tooltip')" /--->
                              </div>
                            </div>
                            <div
                              class="col-lg-6 col-xl-6 align-self-center mb-0"
                            >
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <input
                                    placeholder="Button Url"
                                    type="text"
                                    name="url"
                                    v-model="item.button_url"
                                    v-b-tooltip.hover
                                    :title="$t('cms_btn_url_tooltip')"
                                  />
                                  <label>{{ $t("cms_btn_url") }}</label>
                                </div>
                                <!--Tooltip :title="$t('cms_btn_url_tooltip')" /--->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-1 d-flex align-items-center justify-content-center border-left"
                      >
                        <button
                          v-if="index === 0 && false"
                          @click.prevent.stop="
                            addCMSBlock($event, contentIndex)
                          "
                          class="btn-transparent"
                        >
                          <img
                            src="@/assets/img/icons/plus.svg"
                            height="35"
                            width="35"
                          />
                        </button>
                        <button
                          @click.prevent.stop="
                            removeCMSBlock($event, contentIndex, index)
                          "
                          class="btn-transparent"
                        >
                          <img
                            src="@/assets/img/icons/minus.svg"
                            height="35"
                            width="35"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="row w-100 pl-5">
                      <p class="mx-auto text-muted">Add Block</p>
                    </div>
                  </div>
                  <div
                    class="col-12 d-flex align-items-center justify-content-center border-top mt-5 mb-5 position-relative"
                  >
                    <button
                      @click.prevent.stop="addCMSBlock($event, contentIndex)"
                      class="btn-transparent add-more-button"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>

        <div class="col-md-12 text-center mt-4">
          <button type="submit" class="btn-blue">{{ $t("update") }}</button>
          <!-- <button @click.prevent.stop="onResetForm" class="btn-black">{{ $t('reset') }}</button> -->
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="cinema-settings"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
      <b-modal
        ref="preview-modal"
        id="selected-image-preview-modal"
        size="lg"
        hide-header
        hide-footer
      >
        <label class="h4 mt-2 mb-4 text-center">{{ PreviewHeading }}</label>
        <button
          class="btn-modal-close"
          @click="$bvModal.hide('selected-image-preview-modal')"
        >
          &times;
        </button>
        <br />
        <div v-if="String(previewType) == '2'">
          <img
            :src="
              _GetImagePath(
                CMS[previewLanguage].cmsData[previewIndex].image_url
              )
            "
            class="img-fluid"
          />
        </div>
        <div v-else-if="String(previewType) == '3'">
          <img
            :src="_GetImagePath(CMS[previewLanguage].cmsHeader.image_url)"
            class="img-fluid"
          />
        </div>
        <div v-else-if="String(previewType) == '1'">
          <img
            :src="_GetImagePath(cinema_config.temp_artwork_image_path)"
            class="img-fluid"
          />
        </div>
        <div v-else class="mx-auto w-100">
          {{ "No Preview Available" }}
        </div>
      </b-modal>
    </div>
    <ImageGallery
      v-bind:propImageName="calledBy == 1 ? 'ArtWork Image' : 'Image'"
      v-bind:openModal="showModal"
      v-bind:set_height="calledBy == 1 ? set_height : NaN"
      v-bind:set_width="calledBy == 1 ? set_width : NaN"
      :showPercentageLoader="true"
      :img_desc="calledBy == 1 ? 'Temporary Movie Artwork Image' : 'CMS Image'"
      :resetImgData="false"
      :language="
        calledBy == 2 ? this.ContentLanguages[this.imageLangIndex] : {}
      "
      :category="'Movie Poster'"
    ></ImageGallery>
  </div>
</template>

<script>
  import CinemasService from "@/services/CinemasService";
  import scheduleService from "@/services/scheduleService";
  import MovieService from "@/services/MovieService";
  import MasterService from "@/services/MasterService";
  import moment from "moment";
  import DatePicker from "vue2-datepicker";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";
  import ImageGallery from "../../ImageGallery/imageGalleryModal";
  import { mapGetters } from "vuex";
  import UserService from "../../../../services/UserService";
  import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

  export default {
    components: { DatePicker, VueTimepicker, ImageGallery, VueCropper },
    data() {
      return {
        btenable: false,
        // timeZones: moment.tz.names(),
        timeZones: [],
        selectedTimeZone: "",

        language: [],
        submitted: false,
        selectedCinema: "",
        selectedlanguage: "",
        Cinemas: [],
        selected: null,
        leadTimeHH: "00",
        leadTimeMM: "00",
        cinema_config: {
          discount_is_available_on: "GrossAmount",
          cine_id: null,
          cine_setting_id: null,
          cine_concession_level: "",
          cine_application_language_id: "",
          cine_operation_start_time: "",
          cine_operation_end_time: "",
          online_fnb_start_time: "",
          online_fnb_end_time: "",
          online_fnb_start_time: "",
          online_fnb_end_time: "",
          cine_cleaning_time_in_mins: "",
          cine_setting_ads_time_in_mins: "",
          cine_interval_time_in_mins: "",
          cine_seat_release_time_in_mins: "",
          cine_cutoff_time_in_mins: "",
          kiosk_cutoff_time_in_mins: "",
          website_cutoff_time_in_mins: "",
          entry_after_show_start: "",
          entry_before_show_start: "",
          cine_display_24hr_time: "Y",
          cine_online_visibility: "Y",
          cine_sell_fnb_in_boxoffice: "Y", // Form Label: Sell F&B in Box Office
          cine_direct_sale: "Y", // Form Label: F&B Direct Sale
          optional_ticket_print: "N",
          optional_ticket_print: "N",
          cine_sell_fnb_online: "N", // Form Label: F&B Online Sale
          cine_setting_is_active: "Y",
          cine_time_zone: "",
          cine_ipaddress_range: "",
          cine_include_float_amount: "Y",
          cine_include_shift_close: "Y",
          start_time: "",
          end_time: "",
          fnb_start_time: "",
          fnb_end_time: "",
          fnb_start_time: "",
          fnb_end_time: "",
          mycinema_creation_interval: "",
          start_day: "",
          temp_artwork_image_path: "",
          lead_time_in_hours: "",
        },
        set_width: 2160,
        set_height: 3050,
        showModal: false,
        options: ["Kg", "Gms", "Lt", "Pks", "Ps"],
        cinema_id: null,
        cinema_setting_id: null,
        selectedScreens: [],
        screens: [],
        RemovedScreens: [],
        Days: [
          { id: 1, day: "Monday" },
          { id: 2, day: "Tuesday" },
          { id: 3, day: "Wednesday" },
          { id: 4, day: "Thursday" },
          { id: 5, day: "Friday" },
          { id: 6, day: "Saturday" },
          { id: 7, day: "Sunday" },
        ],
        selected_day: "",
        sectionCollapse: {
          cmsBlock: true,
        },
        CMS: [],
        ContentLanguages: [],
        CMSContent: [],
        activeClass: 0,
        notempty: [false, false, false, false, false, false],
        imageLangIndex: null,
        imageCMSIndex: null,
        calledBy: 0,
        PreviewHeading: "Image Preview",
        previewType: null,
        previewLanguage: null,
        previewIndex: null,
        cinemaID: null,
        soundFormatList: [],
        ApprovalUsers: [],
        selectedApprovalUsers: [],
        ShowTypeArray: [
          {
            booking_type_id: "4",
            screening_name: "Classic",
            column_name: "is_classic_show",
            status: true,
          },
          {
            booking_type_id: "1",
            screening_name: "Confirmed",
            column_name: "is_confirmed_show",
            status: true,
          },
          {
            booking_type_id: "2",
            screening_name: "Crowd Source",
            column_name: "is_crowd_show",
            status: true,
          },
          {
            booking_type_id: "3",
            screening_name: "Private",
            column_name: "is_private_show",
            status: true,
          },
          {
            booking_type_id: "5",
            screening_name: "Movie Club",
            column_name: "is_movie_club",
            status: true,
          },
        ],
      };
    },
    async beforeMount() {
      const { cinema_id, cinema_setting_id } = this.$route.query;
      if (cinema_id && cinema_setting_id) {
        this.getUserList({ cinema_id });
        this.cinema_id = cinema_id;
        this.cinemaID = cinema_id;
        this.cinema_config.cine_setting_id = cinema_setting_id;
        await this.getCinemaList(cinema_id, cinema_setting_id);
        await this.getlanguagelist(cinema_id);
        await this.getAllActiveScreens(cinema_id);
        this.getSoundFormats();
        // await this.getTimeZones();
      } else {
        this.$router.go(-1);
      }
    },
    computed: {
      ...mapGetters(["finalImagePath"]),
      isEmpireClient() {
        return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
      },
      isEmpireClient() {
        return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
      },
    },
    watch: {
      finalImagePath(newval) {
        if (this.calledBy == 2) {
          this.CMS[this.imageLangIndex].cmsData[
            this.imageCMSIndex
          ].image_url = newval;
        } else if (this.calledBy == 1) {
          this.cinema_config.temp_artwork_image_path = newval;
        } else if (this.calledBy == 3) {
          this.CMS[this.imageLangIndex].cmsHeader.image_url = newval;
        }
        this.$forceUpdate();
      },
    },
    methods: {
      getScreenType(columnName) {
        let ShowType = "";
        ShowType = this.ShowTypeArray.find((x) => x.column_name == columnName);
        return ShowType && ShowType.status ? "Y" : "N";
      },
      createShowTypeArray(obj) {
        Object.keys(obj).forEach((x) => {
          this.ShowTypeArray.forEach((y) => {
            if (y["column_name"] == x) {
              y["status"] = obj[x] == "Y";
            }
          });
        });
      },
      onSelectSoundFormatHandler(format, index) {
        console.log("format", format);
        this.CMS[index].cmsHeader.sound_formats.push(format.sound_format_name);
      },
      onRemoveSoundFormat(format, index) {
        let formatIndex = this.CMS[index].cmsHeader.sound_formats.findIndex(
          (x) => {
            return x.sound_format_name == format.sound_format_name;
          }
        );
        this.CMS[index].cmsHeader.sound_formats.splice(formatIndex, 1);
      },
      getSoundFormats: function() {
        let payload = {
          tableName: "ms_sound_formats",
          sound_format_is_active: "Y",
          orderBy: "asc",
          columnName: "sf_order",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.soundFormatList = data.Records;
            } else {
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            console.log("show error :", error);
          });
      },
      onChangeTabHandler: function(event, index) {
        this.activeClass = index;
      },
      addCMSBlock(event, langIndex) {
        let block = {
          title: "",
          description: "",
          image_url: "",
          button_text: "",
          button_url: "",
        };
        this.CMS[langIndex].cmsData.push(block);
        console.log("this.CMS", this.CMS);
        this.$forceUpdate();
      },
      removeCMSBlock(event, LangIndex, index) {
        this.CMS[LangIndex].cmsData.splice(index, 1);
        if (this.CMS[LangIndex].cmsData.length == 0) {
          this.notempty[LangIndex] = false;
        }
        this.$forceUpdate();
      },
      getContentLangauge: function(content) {
        MovieService.GetMovieContentLanguages()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.ContentLanguages.length > 0) {
                // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
                //   "langauge"
                // ]);
                this.ContentLanguages = data.ContentLanguages;
              }
              console.log("this.ContentLanguages", this.ContentLanguages);
            } else {
              // Show Error:
              console.log("data.message :", data.message);
            }
            return;
          })
          .then(() => {
            this.makeLangContainers(content);
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error On getMovieContentLangauge :", error);
          });
      },
      _makeLangContainers: function() {
        this.ContentLanguages.map((x) => {
          let Obj = {
            ...x,
            cinema_id: this.cinemaID,
            cmsData: [],
          };
          this.CMS.push(Obj);
          console.log("this.CMS", this.CMS);
        });
      },
      makeLangContainers: function(Content) {
        console.log("Content", Content);
        this.ContentLanguages.map((x, i) => {
          let Array1 = Content.filter((y) => {
            return y.lang_id == x.langaugeId;
          });
          if (Array1.length > 0) {
            x["cinema_id"] = this.cinemaID;
            x["cmsData"] = JSON.parse(Array1[0].cms_data);
            x["cmsHeader"] = JSON.parse(Array1[0].cms_header_data) || {
              sound_formats: [],
              image_url: "",
              description: "",
              show_cinema_address: "Y",
            };
            // x["selectedFormats"] = this.setSelectedFormat(
            //   x.cmsHeader.sound_formats
            // );
            x["cms_id"] = Array1[0].cms_id;
            x.cmsData.map((z) => {
              if (z.title && z.description) {
                this.notempty[i] = true;
              }
            });
          } else {
            x["cinema_id"] = this.cinemaID;
            x["cmsData"] = [];
            x["selectedFormats"] = [];
            x["cmsHeader"] = {
              sound_formats: [],
              image_url: "",
              description: "",
              show_cinema_address: "Y",
            };
          }
        });
        this.CMS = this.ContentLanguages;
        console.log("hjhf", this.ContentLanguages);
        this.$forceUpdate();
      },
      setSelectedFormat(formatArray) {
        var filtered = [];
        if (formatArray.length > 0) {
          filtered = this.soundFormatList.filter(function(e) {
            return this.indexOf(e) < 0;
          }, formatArray);
        }
        return filtered;
      },
      setModalData() {
        this.calledBy = 1;
        this.showModal = !this.showModal;
      },
      setCMSImageData(type, langIndex, cmsIndex) {
        if (type == "CMS") {
          this.calledBy = 2;
          this.imageLangIndex = langIndex;
          this.imageCMSIndex = cmsIndex;
          this.showModal = !this.showModal;
        } else if (type == "CMS_header") {
          this.calledBy = 3;
          this.imageLangIndex = langIndex;
          this.showModal = !this.showModal;
        }
      },
      openImageModal: function(type, langIndex, index) {
        if (type == "CMS") {
          this.previewType = 2;
          this.previewLanguage = langIndex;
          this.previewIndex = index;
          this.PreviewHeading = "Image Preview";
        } else if (type == "CMS_header") {
          this.previewType = 3;
          this.previewLanguage = langIndex;
          this.PreviewHeading = "Image Preview";
        } else {
          this.previewType = 1;
          this.PreviewHeading = "Temporary Movie Artwork Image";
        }
        this.$refs["preview-modal"].show();
      },
      CheckEmptyContent: function(content, index, langIndex) {
        if (content.title && content.description) {
          this.notempty[langIndex] = true;
        } else {
          this.notempty[langIndex] = false;
        }
      },
      onRemoveScreens(screen) {
        if (screen.is_default_screen == "Y") {
          this.RemovedScreens.push(screen);
        }
      },
      onClickScreen(event, screen, index) {
        console.log("screens log", screen);
        let isExists = this.selectedScreens.find((x) => {
          return x.screen_id == screen.screen_id;
        });
        if (isExists) {
          this.selectedScreens.splice(
            this.selectedScreens.findIndex(function(i) {
              return i.screen_id === screen.screen_id;
            }),
            1
          );
          this.onRemoveScreens(screen);
        } else {
          this.selectedScreens.push(screen);
        }
        console.log("selectedScreens", this.selectedScreens);

        if (event && event.target) {
          event.target.blur();
        }
      },
      onChangeTime(event, type) {
        event = new Date(
          moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
        );
        if (type == "start") {
          this.cinema_config.cine_operation_start_time = event;
        } else if (type == "end") {
          this.cinema_config.cine_operation_end_time = event;
        }
      },
      onChangeFnbTime(event, type) {
        event = new Date(
          moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
        );
        if (type == "start") {
          this.cinema_config.online_fnb_start_time = event;
        } else if (type == "end") {
          this.cinema_config.online_fnb_end_time = event;
        }
      },
      onChangeLeadTime(event, type) {
        let time = event.target.value;

        if (type === "HH") {
          this.leadTimeHH = time;
        } else if (type === "MM") {
          this.leadTimeMM = time;
        }
      },
      onResetForm: function() {
        this.selectedCinema = "";
        this.selectedlanguage = "";
        this.cinema_config = {
          discount_is_available_on: "GrossAmount",
          cine_id: null,
          cine_setting_id: null,
          cine_concession_level: "",
          cine_application_language_id: "",
          cine_operation_start_time: "",
          cine_operation_end_time: "",
          online_fnb_start_time: "",
          online_fnb_end_time: "",
          cine_cleaning_time_in_mins: "",
          cine_setting_ads_time_in_mins: "",
          cine_interval_time_in_mins: "",
          cine_seat_release_time_in_mins: "",
          cine_cutoff_time_in_mins: "",
          kiosk_cutoff_time_in_mins: "",
          website_cutoff_time_in_mins: "",
          cine_display_24hr_time: "Y",
          cine_online_visibility: "Y",
          cine_sell_fnb_in_boxoffice: "Y",
          cine_direct_sale: "Y",
          optional_ticket_print: "N",
          cine_sell_fnb_online: "Y",
          cine_setting_is_active: "Y",
          cine_time_zone: "",
          cine_ipaddress_range: "",
          cine_include_float_amount: "Y",
          start_time: "",
          end_time: "",
          fnb_start_time: "",
          fnb_end_time: "",
          lead_time_in_hours: "00:00",
        };
        this.leadTimeMM = "00";
        this.leadTimeHH = "00";
        this.selectedScreens = [];
      },
      onSelectTimeZone: function(event, params) {
        this.selectedTimeZone = params;
        this.cinema_config.cine_time_zone = params.cine_time_zone;
      },
      onSelectDay(Day) {
        this.selected_day = Day;
        this.cinema_config.start_day = Day.day;
      },
      onSelectCinema: function(event, params) {
        this.selectedCinema = params.cine_name;
        this.cinema_config.cine_id = params.cine_id;
        this.cinemaID = params.cine_id;
        this.getAllActiveScreens(params.cine_id);
      },
      onSelectLanguage: function(event, params) {
        this.selectedlanguage = params.lang_name;
        this.cinema_config.cine_application_language_id = params.lang_id;
        // console.log(this.selectedlanguage);
      },
      getAllActiveScreens: function(cinema_id) {
        console.log("cinema_id :", cinema_id);
        this.ScreenList = [];
        let payload = {
          cinema_id: cinema_id,
        };

        scheduleService
          .GetScreens(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.screens = data.Records.filter((x) => {
                return (
                  x.screen_seat_types.length > 0 &&
                  x.totalSeatLayout > 0 &&
                  x.screen_seat_card_mapping.length >=
                    x.screen_seat_types.length
                );
              });
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveScreens :", error);
          });
      },
      getlanguagelist: function(cinema_id) {
        this.language = [];
        let payload = {
          tableName: "ms_language",
          lang_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.language = data.Records;
              this.language.map((x) => {
                if (x.lang_id == cinema_id) {
                  this.selectedlanguage = x.lang_name;
                  // console.log(this.selectedlanguage);s
                  this.cinema_config.cine_application_language_id = x.lang_id;
                }
              });
            } else {
              console.error("Error:", data.message);
            }
          })
          .catch(this._CatchError);
      },
      getCinemaList: function(cinema_id, cinema_setting_id) {
        // console.log("cienma id :", cinema_id, cinema_setting_id);
        MasterService.GetCinemas({ cine_id: cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              // console.log("this.Cinemas :", this.Cinemas);
              this.Cinemas.map((x) => {
                if (x.cine_id == cinema_id) {
                  this.selectedCinema = x.cine_name;
                  this.cinema_config.cine_id = x.cine_id;
                }
              });
              this.getCinemaSettings(cinema_id, cinema_setting_id);
            } else {
              // Show Error Message:
              this.$router.push(-1);
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getTimeZones: function() {
        CinemasService.getTimeZoneList()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.timeZones = data.Records;
              for (let i in this.timeZones) {
                // console.log(
                //   "this.cinema_config.cine_time_zone :",
                //   this.cinema_config.cine_time_zone
                // );
                // console.log("this.timeZones[i].tz_id :", this.timeZones[i].tz_id);
                if (
                  this.cinema_config.cine_time_zone === this.timeZones[i].tz_id
                ) {
                  // console.log("heree");
                  this.cinema_config.cine_time_zone = this.timeZones[i];
                }
                // console.log("object :", this.cinema_config.cine_time_zone);
              }
              // this.timeZonesAll.map(x => {
              //   this.timeZones = x.tz_name;
              // });
              // console.log("time :", this.timeZones);
            } else {
              // Show Error Message:
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getCinemaSettings: async function(cinema_id, cinema_setting_id) {
        let payload = {
          cinema_id,
          cinema_setting_id,
        };

        await scheduleService
          .PostCinemaSetting(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.createShowTypeArray(data.Records[0]);
                // moment.unix(y.ss_start_date_time).format();
                // data.Records[0].cine_operation_start_time = moment
                //   .unix(data.Records[0].cine_operation_start_time)
                //   .format();
                // data.Records[0].cine_operation_end_time = moment
                //   .unix(data.Records[0].cine_operation_end_time)
                //   .format();

                data.Records[0].cine_operation_start_time =
                  moment().format("YYYY-MM-DD") +
                  " " +
                  data.Records[0].cine_operation_start_time;

                data.Records[0].cine_operation_end_time =
                  moment().format("YYYY-MM-DD") +
                  " " +
                  data.Records[0].cine_operation_end_time;

                this.selectedScreens = data.screens;

                this.cinema_config.start_time =
                  data.Records[0].cine_operation_start_time;
                this.cinema_config.end_time =
                  data.Records[0].cine_operation_end_time;

                this.cinema_config.fnb_start_time =
                  data.Records[0].online_fnb_start_time;
                this.cinema_config.fnb_end_time =
                  data.Records[0].online_fnb_end_time;

                this.selected_day = this.Days.filter((x) => {
                  return x.day == data.Records[0].start_day;
                });
                console.log("this.selected_day", this.selected_day);
                this.cinema_config.temp_artwork_image_path =
                  data.Records[0].temp_movie_artwork_image_path;
                console.log("cinema_config", {
                  ...data.Records[0],
                });
                this.cinema_config = {
                  ...this.cinema_config,
                  ...data.Records[0],
                };
                if (data.CMSData) {
                  this.getContentLangauge(data.CMSData);
                }
                // console.log(
                //   'cinema_config.cine_operation_start_time" :',
                //   this.cinema_config.cine_operation_start_time
                // );

                // console.log("this.cinema_config :", this.cinema_config);
                // console.log("this.timeZones :", this.timeZones);

                // console.log(
                //   "this.cinema_config.cine_time_zone :",
                //   this.cinema_config.cine_time_zone
                // );
                // console.log("this.cinema_config :", this.cinema_config);
                // this.selectedTimeZone = this.cinema_config.cine_time_zone;

                if (
                  data.Records[0]["cine_offer_applicable_on_gross"] &&
                  data.Records[0]["cine_offer_applicable_on_gross"] === "Y"
                ) {
                  this.cinema_config["discount_is_available_on"] =
                    "GrossAmount";
                } else if (
                  data.Records[0]["cine_offer_applicable_on_net"] &&
                  data.Records[0]["cine_offer_applicable_on_net"] === "Y"
                ) {
                  this.cinema_config["discount_is_available_on"] = "NetAmount";
                }

                if (data.Records[0].lead_time_in_hours) {
                  let time = data.Records[0].lead_time_in_hours.split(":");
                  if (time.length) {
                    this.leadTimeHH = time[0];
                    this.leadTimeMM = time[1];
                  }
                }
                if (data.Records[0].po_approval_users) {
                  let currentUserIds = data.Records[0].po_approval_users.split(
                    ","
                  );

                  this.selectedApprovalUsers = this.ApprovalUsers.filter((u) =>
                    currentUserIds.includes(String(u.user_id))
                  );
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
        await this.getTimeZones();
      },

      getUserList: function({ cinema_id }) {
        let body = {
          cinema_id,
        };
        UserService.ListAllUser({}, body)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.ApprovalUsers = data.data;
              console.log("this.users :", this.ApprovalUsers);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      selectPoUser: function(event) {
        this.$forceUpdate();
        //this.selectedUserString = this.selectedApprovalUsers.map(u => u.user_id).join(',')
      },

      onFinalSubmit: function(flag) {
        this.submitted = true;
        console.log("this.cinema_config", this.cinema_config);
        console.log("screens", this.selectedScreens);
        console.log("Removedscreens", this.RemovedScreens);
        function format24Hours(date) {
          let newVal = date;
          let finalVal = moment(newVal).format("H:mm");
          return finalVal;
        }
        this.$validator.validate().then((valid) => {
          console.log("valid :", valid);
          if (valid) {
            this.btenable = true;
            this.cinema_config.cine_time_zone = this.cinema_config.cine_time_zone.tz_id;

            if (this.leadTimeMM.length === 1)
              this.leadTimeMM = `0${this.leadTimeMM}`;
            this.cinema_config.lead_time_in_hours = `${this.leadTimeHH}:${this.leadTimeMM}`;
            let loader = this.$loading.show();
            let payload = {
              ...this.cinema_config,
              cine_operation_start_time: moment(
                this.cinema_config.cine_operation_start_time
              ).format("HH:mm"),
              cine_operation_end_time: moment(
                this.cinema_config.cine_operation_end_time
              ).format("HH:mm"),
              online_fnb_start_time:
                moment(this.cinema_config.online_fnb_start_time).format(
                  "HH:mm"
                ) ||
                moment(this.cinema_config.cine_operation_start_time).format(
                  "HH:mm"
                ),
              online_fnb_end_time:
                moment(this.cinema_config.online_fnb_end_time).format(
                  "HH:mm"
                ) ||
                moment(this.cinema_config.cine_operation_end_time).format(
                  "HH:mm"
                ),
              cinema_id: this.cinema_config.cine_id,
              cinema_setting_id: this.cinema_config.cine_setting_id,
              cine_offer_applicable_on_gross: "N",
              cine_offer_applicable_on_net: "N",
              screens: this.selectedScreens,
              RemovedScreens: this.RemovedScreens,
              CMS: this.CMS,
              mycinema_creation_interval:
                parseInt(this.cinema_config.mycinema_creation_interval) || null,
              // cinema_concession_level: this.cinema_config.cinema_concession_level,
              po_approval_users: this.selectedApprovalUsers
                .map((u) => u.user_id)
                .join(","),
            };

            // console.log(
            //   "this.cinema_config.cine_time_zone && :",
            //   this.cinema_config.cine_time_zone,
            //   this.cinema_config.cine_time_zone.length > 0
            // );

            if (this.cinema_config.cine_time_zone) {
              if (
                this.cinema_config["discount_is_available_on"] &&
                this.cinema_config["discount_is_available_on"] === "GrossAmount"
              ) {
                payload["cine_offer_applicable_on_gross"] = "Y";
              } else if (
                this.cinema_config["discount_is_available_on"] &&
                this.cinema_config["discount_is_available_on"] === "NetAmount"
              ) {
                payload["cine_offer_applicable_on_net"] = "Y";
              }

              payload.is_confirmed_show = this.getScreenType(
                "is_confirmed_show"
              );
              payload.is_private_show = this.getScreenType("is_private_show");
              payload.is_crowd_show = this.getScreenType("is_crowd_show");
              payload.is_movie_club = this.getScreenType("is_movie_club");
              payload.is_classic_show = this.getScreenType("is_classic_show");

              scheduleService
                .UpdateCinemaSetting(payload)
                .then((response) => {
                  this.btenable = false;
                  const { data } = response;
                  if (data && data.status) {
                    loader.hide();
                    this.$toasted.show("Cinema Setting Updated Successfully");
                    this.onResetForm();
                    this.$router.push({
                      path: "/cinema-manager/cinemas",
                    });
                  } else {
                    this.$toasted.show(data.message);
                  }
                })
                .catch(this._CatchError);
            } else {
              this.$toasted.show("Please Select Time Zone");
            }
          }
        });
      },
    },
  };
</script>

<style>
  .img-preview:hover {
    left: -137px !important;
  }

  .section-collapse-box {
    border: 1px solid var(--lightgrey);
    border-radius: 10px;
    padding: 10px;
  }

  .cms-section-new .section-title {
    font-size: 22px;
  }
  .cms_header_image {
    max-width: 400px;
  }
  .new-border {
    border: 2px solid #b1b4b8;
  }
  .back {
    background-color: #fff;
  }
  .back-sam {
    background-color: green;
  }
  .back-white {
    background-color: white;
    border: 1px solid #b1b4b8;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemaSettingsComponents/editCinemaSettings.vue